(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let pending;
  let requestNumber = 0;
  const initArticle = () => {
    const article = document.querySelector('.hug-article');
    if (!article) return;
    const hero = article.querySelector('.hug-article__hero');
    const heroImage = hero?.querySelector('img');
    if (heroImage) {
      const name = src => { try { return decodeURIComponent(new URL(src, location.href).pathname.split('/').pop()).toLowerCase(); } catch { return ''; } };
      const heroName = name(heroImage.src);
      for (const figure of article.querySelectorAll('.hug-article__content figure')) {
        const image = figure.querySelector('img');
        if (image && figure.querySelectorAll('img').length === 1 && name(image.src) === heroName) {
          const caption = figure.querySelector('figcaption');
          if (caption) hero.append(caption.cloneNode(true));
          figure.hidden = true;
          break;
        }
      }
    }
    article.querySelectorAll('.hug-article__content > p').forEach(p => {
      if (p.textContent.trim() === article.dataset.pastLabel) p.hidden = true;
    });
    article.querySelectorAll('[data-hug-copy]').forEach(button => {
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(document.querySelector('link[rel="canonical"]').href);
          button.textContent = button.dataset.copied;
          setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 2200);
        } catch { button.textContent = button.dataset.copyLabel; }
      });
    });
  };
  let observer;
  let loadingMore = false;
  let moreController;
  let seenPages = new Set();
  const previewUrl = value => {
    const url = new URL(value, location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = '';
    return url;
  };
  const observeMore = () => {
    observer?.disconnect();
    const sentinel = document.querySelector('[data-journal-sentinel]');
    if (!sentinel || !document.querySelector('[data-journal-next]') || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting) && !document.hidden) loadMore();
    }, { rootMargin: '250px 0px' });
    observer.observe(sentinel);
  };
  const loadMore = async (manual = false, keyboard = false) => {
    const archive = document.querySelector('.hug-journal');
    const link = archive?.querySelector('[data-journal-next]');
    if (!link || loadingMore || archive.classList.contains('is-loading')) return;
    const url = previewUrl(link.href);
    if (seenPages.has(url.href)) return;
    const generation = requestNumber;
    const oldFooter = archive.querySelector('[data-journal-more]');
    const status = archive.querySelector('[role="status"]');
    const controller = new AbortController();
    moreController = controller;
    loadingMore = true;
    link.setAttribute('aria-disabled', 'true');
    oldFooter.setAttribute('aria-busy', 'true');
    link.textContent = archive.dataset.loading;
    const timeout = setTimeout(() => controller.abort(), 12000);
    observer?.disconnect();
    let succeeded = false;
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Load failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.querySelector('.hug-journal');
      const grid = archive.querySelector('.hug-journal-grid');
      if (!next || !grid || generation !== requestNumber || !archive.isConnected) return;
      const known = new Set([...grid.querySelectorAll('.hug-story__media')].map(a => a.getAttribute('href')));
      const cards = [...next.querySelectorAll('.hug-journal-grid > .hug-story')].filter(card => {
        const key = card.querySelector('.hug-story__media')?.getAttribute('href');
        if (key && known.has(key)) return false;
        if (key) known.add(key);
        return true;
      });
      if (!cards.length && next.querySelector('[data-journal-next]')?.href === link.href) throw new Error('Repeated page');
      grid.append(...cards);
      const footer = next.querySelector('[data-journal-more]');
      if (!footer) throw new Error('Navigation missing');
      oldFooter.replaceWith(footer);
      seenPages.add(url.href);
      status.textContent = archive.dataset.loaded;
      if (manual && keyboard) cards[0]?.querySelector('a')?.focus({ preventScroll: true });
      succeeded = true;
    } catch {
      if (generation !== requestNumber || !archive.isConnected) return;
      link.textContent = archive.dataset.retry;
      link.removeAttribute('aria-disabled');
      oldFooter.removeAttribute('aria-busy');
      status.textContent = archive.dataset.loadError;
    } finally {
      clearTimeout(timeout);
      if (generation === requestNumber) {
        loadingMore = false;
        if (succeeded) observeMore();
      }
    }
  };
  const navigate = async (value, push = true, focus = false) => {
    const current = document.querySelector('.hug-journal');
    if (!current) { location.assign(value); return; }
    pending?.abort();
    moreController?.abort();
    observer?.disconnect();
    loadingMore = false;
    seenPages = new Set();
    pending = new AbortController();
    const controller = pending;
    const ownRequest = ++requestNumber;
    const fetchUrl = previewUrl(value);
    const historyUrl = new URL(fetchUrl);
    historyUrl.hash = 'blog_filters';
    current.classList.add('is-loading');
    current.setAttribute('aria-busy', 'true');
    const status = current.querySelector('[role="status"]');
    if (status) status.textContent = current.dataset.loading;
    const timeout = setTimeout(() => controller.abort('timeout'), 12000);
    try {
      const response = await fetch(fetchUrl, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Navigation failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (ownRequest !== requestNumber) return;
      const next = parsed.querySelector('.hug-journal');
      if (!next) throw new Error('Archive missing');
      const replace = () => {
        current.replaceWith(next);
        if (push) history.pushState({}, '', historyUrl);
        if (focus) (next.querySelector('.hug-journal-search input[type="search"]') || next.querySelector('[aria-current="page"]'))?.focus({ preventScroll: true });
      };
      if (document.startViewTransition && !reduced.matches) {
        current.classList.remove('is-loading');
        await document.startViewTransition(replace).finished;
      } else {
        next.classList.toggle('is-entering', !reduced.matches);
        replace();
        requestAnimationFrame(() => requestAnimationFrame(() => next.classList.remove('is-entering')));
      }
      if (ownRequest !== requestNumber) return;
      if (next.dataset.pageTitle) document.title = next.dataset.pageTitle;
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical && next.dataset.canonical) canonical.href = next.dataset.canonical;
      next.querySelector('[role="status"]').textContent = next.dataset.loaded;
      if (push) next.querySelector('.hug-journal-filter')?.scrollIntoView({ behavior: 'instant', block: 'start' });
      observeMore();
    } catch {
      if (ownRequest !== requestNumber) return;
      current.classList.remove('is-loading');
      current.removeAttribute('aria-busy');
      if (status) status.textContent = '';
      if (!controller.signal.aborted || controller.signal.reason === 'timeout') location.assign(historyUrl);
    } finally { clearTimeout(timeout); }
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest('.hug-journal-search');
    if (!form) return;
    const terms = form.querySelector('[name="q"]').value.trim();
    if (!terms) return;
    event.preventDefault();
    const url = new URL(form.action, location.href);
    for (const [key, value] of new FormData(form)) url.searchParams.set(key, value);
    navigate(url, true, true);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('.hug-journal-filter a, .hug-journal-reset, [data-journal-next]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    if (link.matches('[data-journal-next]')) { loadMore(true, event.detail === 0); return; }
    if (link.getAttribute('aria-current') === 'page') return;
    navigate(url, true, event.detail === 0);
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.hug-journal-filter details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.hug-journal-filter details[open]');
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
  window.addEventListener('popstate', () => { if (document.querySelector('.hug-journal')) navigate(location.href, false); });
  window.addEventListener('pageshow', () => { document.querySelector('.hug-journal')?.classList.remove('is-loading'); observeMore(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) observeMore(); });
  initArticle();
  observeMore();
})();
